import { Box, styled, Typography } from '@mui/material';

export const EditorBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{ hasError: boolean }>(({ theme, hasError }) => ({
  border: `1px solid ${hasError ? theme.palette.error.main : '#C4C4C4'}`,
  borderRadius: '16px',
  overflow: 'hidden',
  cursor: 'default',

  '&:focus-within': {
    borderColor: hasError
      ? theme.palette.error.main
      : theme.palette.secondary.main,
  },

  '& .rich-text-content': {
    padding: '12px 16px 4px',
  },

  '& .ProseMirror': {
    minHeight: '96px',
    maxHeight: '240px',
    overflow: 'auto',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    color: '#1A1A1A',
    cursor: 'text',

    ':focus-visible': { outline: 'none' },

    p: { margin: '0 0 8px', overflowWrap: 'anywhere' },

    a: {
      color: theme.palette.secondary.main,
    },

    'p.is-editor-empty:first-of-type::before': {
      color: '#9CA3AF',
      content: 'attr(data-placeholder)',
      float: 'left',
      height: 0,
      pointerEvents: 'none',
    },
  },
}));

export const CharCount = styled(Typography)(() => ({
  textAlign: 'right',
  color: '#9CA3AF',
  fontSize: '12px',
  padding: '0 16px 8px',
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '12px',
  padding: '0 16px 8px',
}));
